import { useState } from 'react';

export const useNavbarCategoriesDrawer = () => {
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [productosOpen, setProductosOpen] = useState(false);
  const [expandedCategories, setExpandedCategories] = useState<number[]>([]);

  const openDrawer = () => setDrawerOpen(true);
  
  const closeDrawer = () => {
    setDrawerOpen(false);
    setProductosOpen(false);
    setExpandedCategories([]);
  };

  const toggleDrawer = () => {
    if (drawerOpen) {
      closeDrawer();
    } else {
      openDrawer();
    }
  };

  const toggleProductos = () => setProductosOpen(!productosOpen);

  const toggleCategory = (categoryId: number) => {
    setExpandedCategories(prev =>
      prev.includes(categoryId)
        ? prev.filter(id => id !== categoryId)
        : [...prev, categoryId]
    );
  };

  return {
    drawerOpen,
    productosOpen,
    expandedCategories,
    openDrawer,
    closeDrawer,
    toggleDrawer,
    toggleProductos,
    toggleCategory,
  };
};














